module.exports = __webpack_public_path__ + "img/monitorbox27.674fbcb0.jpg";